import { generatePath } from 'react-router';

import type { NavigableRouteType } from '@/router/types';

export const app = {
  path: '/app',
  description: 'The root path of the application.',
  navigable: true,
  pathParams: {},
  searchParams: {},
} satisfies NavigableRouteType;

export const instance = {
  path: '/app/inst/:instance',
  description: 'The root path of the application for a specific organization.',
  navigable: true,
  pathParams: {},
  searchParams: {},
} satisfies NavigableRouteType;

export const appByInstanceId = (instanceId: string) => {
  if (instanceId.startsWith('inst:')) {
    const instanceSlug = instanceId.replace(/^inst:/, '');
    return generatePath(instance.path, { instance: instanceSlug });
  }
  return generatePath(instance.path, { instance: instanceId });
};
